import Vue from 'vue';
import { Component, Watch, Inject } from 'vue-property-decorator';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import qs from 'qs';
import template from './savedProduct.vue';
import ProductModal from '../../components/productModal';
import DefaultModal from '../../components/modal';
import MessageModal from '../../components/messageModel';
import { Validator } from 'vee-validate';
import uploader from '../../components/uploader';
import util from '../../shared/util';
import Pager from '../../components/pager';
import UnisDefaultSelect from '../../components/unisDefaultSelect';
import UnisProductModal from '../../components/unisProductModal';
import switchBillingToService from '../../shared/switchBillingToService';
import { analytics } from '../../services/analytics';

@Component({
    mixins: [template],
    components: {
        ProductModal,
        DefaultModal,
        MessageModal,
        uploader,
        Pager,
        UnisDefaultSelect,
        UnisProductModal,
    },
})
export default class SavedProduct extends Vue {
    @Inject() $validator: Validator;
    templateCsv = require('../../assets/files/product_import_template.csv');
    validationStarted = true;
    palletDimensionsOptions = this.$store.getters.quoteData.palletDimensionsOptions;
    editProductModalTitle: string = '';
    editProductModalRightBtn: string = '';
    editProductModalLeftBtn: string = 'Close';
    editProductModal: string = 'editProductModal';
    deleteProductModal: string = 'deleteProductModal';
    productModal: string = 'productModal';
    productDetails: any = {};
    importProductModal: string = 'importProductModal';
    importError = false;
    importFile = {};
    paging: any = {};
    importHasFile = false;
    exportFile = 0;

    bill_to: any = 0;
    isLoading = false;
    loadingModal = false;
    productDetail: any = {
        tms_product_id: 0,
        tms_product_name: '',
        tms_product_description: '',
        tms_product_pallet_dimensions: 4,
        tms_product_length: '',
        tms_product_width: '',
        tms_product_height: '',
        tms_product_weight: '',
        tms_product_stackable: 1,
    };

    // items in pagination
    products: Array<Object> = [];
    products_total = 0;
    pagination = {
        currentProductsStart: 1,
        currentProductsEnd: 15,
        max: 15,
        total: 0,
        totalPaginationCount: 0,
        paginationLink: {},
        paginationSet: {},
        currentPaginationIndex: 0,
        paginationStart: 0,
        paginationEnd: 5,
        hide: false,
    };

    productName = '';

    deleteProductDetail: any = {
        tms_product_id: 0,
        tms_product_name: '',
        tms_product_description: '',
        tms_product_pallet_dimensions: 4,
        tms_product_length: '',
        tms_product_width: '',
        tms_product_height: '',
        tms_product_weight: '',
        tms_product_stackable: 1,
    };

    messageModalName: string = 'messageModalName';
    messageModalTitle: string = 'Success';
    messageModalMessage: string = 'Success';

    palletClass: Array<string> = [
        '50',
        '55',
        '60',
        '65',
        '70',
        '77',
        '85',
        '92',
        '100',
        '110',
        '125',
        '150',
        '175',
        '200',
        '250',
        '300',
        '400',
        '500',
    ];

    widthLock = false;
    lengthLock = false;

    mounted() {
        this.getCustomerData();
    }

    async getCustomerData() {
        switchBillingToService
            .post()
            .then((res: any) => {
                if (res.data.billing != null) {
                    this.bill_to = res.data.billing.location_id;
                }
                this.getProducts(1);
            })
            .catch(error => {
                console.log(error);
            });
    }

    initProductData() {
        this.products = [];
        this.products_total = 0;
        this.pagination = {
            currentProductsStart: 1,
            currentProductsEnd: 15,
            max: 15,
            total: 0,
            totalPaginationCount: 0,
            paginationLink: {},
            paginationSet: {},
            currentPaginationIndex: 0,
            paginationStart: 0,
            paginationEnd: 5,
            hide: false,
        };
        this.productDetail = {
            tms_product_id: 0,
            tms_product_name: '',
            tms_product_description: '',
            tms_product_pallet_dimensions: 4,
            tms_product_length: '',
            tms_product_width: '',
            tms_product_height: '',
            tms_product_weight: '',
            tms_product_stackable: 1,
        };

        Object.assign(this.deleteProductDetail, this.productDetail);
    }

    async getProducts(page: any) {
        const _this = this;
        if (page <= 0 || page > this.pagination.totalPaginationCount) {
            page = 1;
        }
        this.isLoading = true;
        this.initProductData();
        tmsServiceBackend
            .post(
                'product/getProducts',
                qs.stringify({
                    bill_to: this.bill_to,
                    page: page,
                    keyword: this.productName,
                    page_size: this.paging.currentPage,
                })
            )
            .then(function(response) {
                const result = response.data;
                if (result.status == 1) {
                    _this.paging.total = result.data.total;
                    _this.paging.per_page = result.data.per_page;
                    _this.paging.current_page = result.data.current_page;
                    _this.products = result.data.data;
                    _this.products_total = result.data.total;
                    _this.pagination.total = result.data.total;
                    _this.pagination.max = result.data.per_page;
                    _this.pagination.currentPaginationIndex = result.data.current_page;
                    _this.pagination.totalPaginationCount = result.data.last_page;
                    _this.updatePaginationLink(_this.pagination.currentPaginationIndex);
                } else {
                    _this.messageModalTitle = 'Error';
                    _this.messageModalMessage = result.message ? result.message : 'Service error';
                    _this.$modal.show(_this.messageModalName);
                }
                _this.isLoading = false;
            })
            .catch(function(error) {
                _this.isLoading = false;
            });
    }

    updatePaginationLink(paginationIndex: any) {
        let limiter: number = 4;
        let offset: number = 2;
        let link: object[] = [];

        this.pagination.currentProductsStart =
            (this.pagination.currentPaginationIndex - 1) * this.pagination.max + 1;
        this.pagination.currentProductsEnd =
            this.pagination.currentPaginationIndex * this.pagination.max > this.pagination.total
                ? this.pagination.total
                : this.pagination.currentPaginationIndex * this.pagination.max;
        // paginationIndex += 1;

        if (paginationIndex >= limiter) {
            let start: number = paginationIndex - offset;
            let end: number = paginationIndex + offset;

            this.pagination.paginationStart = start;
            this.pagination.paginationEnd = end;

            for (let i: number = start; i <= end - 1; i++) {
                link.push({
                    value: i,
                    index: i - 1,
                });
                if (i == this.pagination.totalPaginationCount) {
                    break;
                }
            }
        } else {
            for (let i: number = 1; i <= this.pagination.totalPaginationCount; i++) {
                if (i <= limiter) {
                    link.push({
                        value: i,
                        index: i - 1,
                    });
                } else {
                    break;
                }
            }
        }
        this.pagination.paginationLink = link;
    }

    editProductAction(index: any) {
        this.productDetail = {
            tms_product_id: 0,
            tms_product_name: '',
            tms_product_description: '',
            tms_product_pallet_dimensions: 4,
            tms_product_length: '',
            tms_product_width: '',
            tms_product_height: '',
            tms_product_weight: '',
            tms_product_stackable: 1,
        };
        if (index == null) {
            this.editProductModalTitle = 'Add new product';
            this.editProductModalRightBtn = 'Save';
        } else {
            Object.assign(this.productDetail, this.products[index]);
            this.editProductModalTitle = 'Edit product';
            this.editProductModalRightBtn = 'Save';
        }
        this.$modal.show(this.editProductModal);
    }
    deleteProduct(index: any) {
        this.deleteProductDetail = this.products[index];
        this.$modal.show(this.deleteProductModal);
    }

    closeModal(modal_name: any) {
        if (modal_name == 'edit' || modal_name == 'add') {
            this.$modal.hide(this.editProductModal);
        } else if (modal_name == 'delete') {
            this.$modal.hide(this.deleteProductModal);
        } else {
            this.deleteFile();
            this.$modal.hide(modal_name);
        }
    }

    deleteHandle(product_id: any) {
        if (product_id == 0) {
            this.messageModalTitle = 'Error';
            this.messageModalMessage = 'Please select the product to be deleted.';
            this.$modal.show(this.messageModalName);
        }
        this.loadingModal = true;
        this.$modal.hide(this.deleteProductModal);
        tmsServiceBackend
            .post(
                'product/deleteProduct',
                qs.stringify({ bill_to: this.bill_to, product_id: product_id })
            )
            .then(res => {
                this.loadingModal = false;
                const result = res.data;
                if (result.status) {
                    this.messageModalTitle = 'Success';
                    this.messageModalMessage = 'Delete product successfully.';
                    this.$modal.show(this.messageModalName);
                    this.getProducts(1);
                } else {
                    this.messageModalTitle = 'Error';
                    this.messageModalMessage = result.message ? result.message : 'Service error';
                    this.$modal.show(this.messageModalName);
                }
            })
            .catch(err => {
                this.loadingModal = false;
                this.$modal.hide(this.deleteProductModal);
                this.messageModalTitle = 'Error';
                this.messageModalMessage = 'Service error';
                this.$modal.show(this.messageModalName);
            });
    }

    saveProduct() {
        this.validate();
    }

    async validate() {
        this.validationStarted = true;
        let result = await this.$validator.validateAll();
        let data = {
            bill_to: this.bill_to,
            ...this.productDetail,
        };
        if (result) {
            this.loadingModal = true;
            this.$modal.hide(this.editProductModal);
            tmsServiceBackend
                .post('product/saveProduct', qs.stringify(data))
                .then(res => {
                    this.loadingModal = false;
                    const result = res.data;
                    if (result.status) {
                        this.messageModalTitle = 'Success';
                        this.messageModalMessage = 'Saved product successfully.';
                        this.$modal.show(this.messageModalName);
                        let page =
                            this.productDetail.tms_product_id == 0
                                ? 1
                                : this.pagination.currentPaginationIndex;
                        this.getProducts(page);
                    } else {
                        this.messageModalTitle = 'Error';
                        this.messageModalMessage = result.message
                            ? result.message
                            : 'Service error';
                        this.$modal.show(this.messageModalName);
                    }
                })
                .catch(err => {
                    this.loadingModal = false;
                    this.$modal.hide(this.deleteProductModal);
                    this.messageModalTitle = 'Error';
                    this.messageModalMessage = 'Service error';
                    this.$modal.show(this.messageModalName);
                });
        }
    }

    @Watch('productDetail.tms_product_pallet_dimensions')
    onPalletTypeChanged(val: string, oldVal: string, event: any) {
        let dimension = this.$store.getters.palletDimension(val);
        const change_dimension = { width: '', length: '' };
        Object.assign(change_dimension, dimension);
        if (change_dimension.width) {
            this.widthLock = true;
            this.productDetail.tms_product_width = change_dimension.width;
        } else {
            this.widthLock = false;
        }
        if (change_dimension.length) {
            this.lengthLock = true;
            this.productDetail.tms_product_length = change_dimension.length;
        } else {
            this.lengthLock = false;
        }
    }
    @Watch('importFile')
    onHasImportFile(val: any, oldVal: any, event: any) {
        if (val[0]) {
            this.importHasFile = true;
        } else {
            this.importHasFile = false;
        }
    }

    importModalShow() {
        this.$modal.show(this.importProductModal);
    }

    importProduct() {
        let formData = new FormData();
        formData.append('bill_to', this.bill_to);
        formData.append('file', this.importFile[0]);
        tmsServiceBackend
            .post('/product/importProduct', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                transformRequest: [
                    data => {
                        return data;
                    },
                ],
            })
            .then(res => {
                let result = res.data;
                if (result.status) {
                    this.messageModalTitle = 'Success';
                    this.messageModalMessage = 'Import the file successfully';
                    this.$modal.show(this.messageModalName);
                    this.getProducts(1);
                    this.$modal.hide(this.importProductModal);
                    this.deleteFile();
                } else {
                    this.importError = true;
                }
            })
            .catch(error => {});
    }

    addFile(file: any) {
        this.importFile = file;
    }
    uploadFile(file: any) {
        this.importFile = file;
    }

    deleteFile() {
        this.importHasFile = false;
        this.importFile = {};
        this.importError = false;
    }

    searchProduct() {
        if (!this.isLoading) {
            this.getProducts(1);
        }
    }

    ExportFileAciton() {
        this.exportFile = 1;
        let _this = this;
        this.loadingModal = true;
        if (!this.isLoading) {
            tmsServiceBackend
                .post(
                    'product/getProducts',
                    qs.stringify({
                        bill_to: this.bill_to,
                        keyword: this.productName,
                        exportFile: this.exportFile,
                    })
                )
                .then(function(response) {
                    let result = response.data;
                    if (result.status != 0) {
                        let date = new Date(+new Date() + 8 * 3600 * 1000)
                            .toJSON()
                            .substr(0, 19)
                            .replace('T', '');
                        let fileName = 'product_export_' + date + '.csv';
                        result = '\ufeff' + result;
                        let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
                        let downloadUrl = URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        analytics.trackFileDownload({
                            fileName: 'saved_product_export',
                            fileType: 'csv',
                        });
                    } else {
                        _this.messageModalTitle = 'Error';
                        _this.messageModalMessage = result.message
                            ? result.message
                            : 'Service error';
                        _this.$modal.show(_this.messageModalName);
                    }
                    _this.loadingModal = false;
                    _this.isLoading = false;
                })
                .catch(function(error) {
                    _this.isLoading = false;
                    _this.loadingModal = false;
                });
        }
    }

    DownloadFile(url: string, name: string) {
        util.exportFile(url, name);
        analytics.trackFileDownload({
            fileName: 'saved_product_template',
            fileType: 'csv',
        });
    }

    triggerSearchFromPager(item: any) {
        this.paging.currentPage = item.pageSize;
        this.getProducts(item.currentPage);
    }

    async productView(item: any, index: any) {
        this.productDetails = item;
        this.$set(this.productDetails, 'index', index);
        await this.getRelatedOrders(this.productDetails);
        this.$modal.show(this.productModal);
    }
    getRelatedOrders(Details: any) {
        tmsServiceBackend
            .get(
                `cpv2/product/getRelatedOrders?product_id=${Details.tms_product_id}&billto_id=${
                    this.bill_to
                }`
            )
            .then(res => {
                let result = res.data;
                console.log(result.data);
                console.log(result.status);
                if (result.status == 1) {
                    this.$set(this.productDetails, 'relatedShipments', result.data);
                } else {
                    this.importError = true;
                }
            })
            .catch(error => {});
    }

    closeProductModal() {
        this.$modal.hide(this.productModal);
    }

    editProductModalAction() {
        this.$modal.hide(this.productModal);
        this.editProductAction(this.productDetails.index);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/savedProduct/index.ts